import React from 'react';
import { compose } from 'react-recompose';
// components
import { FormFooter } from '../form-footer';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// ui
import { Box, Flex } from '../../ui';
// component edit-report
import SortList from '../edit-report/components/sort-list';
import FilterList from '../edit-report/components/filter-list';
import { buildReport, isNotReportValid } from '../edit-report/helpers';
import { withReportSortList } from '../edit-report/components/sort-list/hocs';
import { withReportFilterList } from '../edit-report/components/filter-list/hocs';
//////////////////////////////////////////////////

const ReportFiltersEditor = (props) => {
  const {
    closeModal,
    reportType,
    handleChange,
    filterAvailableFields,
  } = props;

  const handleSave = () => {
    const report = buildReport({
      ...props,
      prompt: false,
      showIssues: false,
      reportFieldList: [],
      showReportSummary: false,
      disableSetReportFields: true,
      usedReport: { [GC.FIELD_TYPE]: reportType },
    });

    if (isNotReportValid(report)) return;

    handleChange({
      sort: report.orderFields,
      filters: report.searchCriteria,
    });
    closeModal();
  };

  return (
    <Box bg={G.getTheme('colors.white')}>
      <Flex maxWidth='95vw' overflowX='auto' alignItems='flex-start'>
        <SortList {...props} />
        <FilterList
          {...props}
          disablePrompt={true}
          useMenuPortalTarget={true}
          availableFields={filterAvailableFields}
        />
      </Flex>
      <FormFooter
        boxStyles={{ p: 15 }}
        cancelAction={closeModal}
        submitAction={handleSave}
        submitBtnText={G.getWindowLocale('actions:submit', 'Submit')}
      />
    </Box>
  );
};

const enhance = compose(
  withReportSortList,
  withReportFilterList,
);

export default enhance(ReportFiltersEditor);
